import React, { useEffect, useState } from "react";
import AdminMenu from "./AdminMenu";
import axios from "axios";
//eslint-disable-next-line
import { Link, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { server } from "../server";
import { Select } from "antd";
import { IoCloseCircleSharp } from "react-icons/io5";
const { Option } = Select;

const UpdateCar = () => {
  const params = useParams();

  const [name, setname] = useState("");
  const [brand, setbrand] = useState({});
  // const [brands, setBrands] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [description, setdescription] = useState("");
  const [price, setprice] = useState("");
  const [fuelType, setfuelType] = useState("");
  const [transmission, settransmission] = useState("");
  const [engineSize, setengineSize] = useState("");
  const [mileage, setmileage] = useState("");
  const [safetyrating, setsafetyrating] = useState("");
  const [yom, setyom] = useState("");
  const [seater, setseater] = useState("");
  const [drive, setdrive] = useState("");
  const [horsepower, sethorsepower] = useState("");
  const [torque, settorque] = useState("");
  const [accelaration, setaccelaration] = useState("");
  const [size, setsize] = useState("");
  const [fuelTank, setfuelTank] = useState("");
  const [id, setId] = useState("");

  const [documents, setdocuments] = useState([]);

  const navigate = useNavigate();

  const getSingleProduct = async () => {
    try {
      const { data } = await axios.get(
        `${server}/api/car/getCarById-car/${params.slug}`,
      );

      setname(data.car.name);
      setdescription(data.car.description);
      setbrand(data.car.brand);
      setprice(data.car.price);
      setfuelType(data.car.fuelType);
      settransmission(data.car.transmission);
      setengineSize(data.car.engineSize);
      setmileage(data.car.mileage);
      setsafetyrating(data.car.safetyrating);
      setyom(data.car.yom);
      setseater(data.car.seater);
      setdrive(data.car.drive);
      sethorsepower(data.car.horsepower);
      settorque(data.car.torque);
      setaccelaration(data.car.accelaration);
      setsize(data.car.size);
      setfuelTank(data.car.fuelTank);
      setId(data.car._id);
      setdocuments(data.car.documents);
    } catch (err) {
      console.log(err);
    }
  };

  const onImageInput = async (e) => {
    let files = Array.from(e.target.files);
    const toastId = toast.loading("Uploading Images. Please Wait... ");
    for (const file of files) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", "car-dellers-threedolts");
      formData.append("folder", "documents");

      try {
        const data = await fetch(
          "https://api.cloudinary.com/v1_1/dqv3ihfrx/image/upload",
          {
            method: "POST",
            body: formData,
          },
        );

        const uploadedImage = await data.json();

        const imageData = {
          url: uploadedImage.secure_url,
          public_id: uploadedImage.public_id,
        };
        setSelectedImages((prevImages) => [...prevImages, imageData]);
        toast.dismiss(toastId);
      } catch (error) {
        toast.dismiss(toastId);
        if (error.response) {
          console.error("Error response data:", error.response.data);
          console.error("Error response status:", error.response.status);
        } else if (error.request) {
          console.error("Error request:", error.request);
        } else {
          console.error("Error message:", error.message);
        }
        toast.error("Error uploading image");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const toastId = toast.loading("Updating...");
    try {
      const carData = new FormData();
      carData.append("name", name);
      carData.append("price", price);
      carData.append("fuelType", fuelType);
      carData.append("transmission", transmission);
      carData.append("engineSize", engineSize);
      carData.append("mileage", mileage);
      carData.append("safetyrating", safetyrating);
      carData.append("yom", yom);
      carData.append("seater", seater);
      carData.append("drive", drive);
      carData.append("horsepower", horsepower);
      carData.append("torque", torque);
      carData.append("accelaration", accelaration);
      carData.append("size", size);
      carData.append("fuelTank", fuelTank);
      carData.append("description", description);
      carData.append("brand", brand);

      // Send new selected images as JSON stringified objects
      selectedImages.forEach((image) => {
        carData.append("documents", JSON.stringify(image));
      });

      const { data } = await axios.put(
        `${server}/api/car/update-car/${id}`,
        carData,
      );

      if (data.success) {
        toast.dismiss(toastId);
        toast.success("Car Updated Successfully");
        navigate("/dashboard/admin/cars");
      } else {
        toast.dismiss(toastId);

        toast.error(data.message);
      }
    } catch (err) {
      toast.dismiss(toastId);
      console.log(err);
    }
  };

  const getAllBrads = async () => {
    try {
      const { data } = await axios.get(`${server}/api/brand/getAll-brand`);
      if (data.success) {
        // setBrands(data?.brands);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllBrads();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getSingleProduct();
    window.scrollTo(0, 0);
    //eslint-disable-next-line
  }, []);

  const deleteImage = async (image) => {
    const toastId = toast.loading("Deleting ...");
    await axios
      .delete(`${server}/api/car/delete-image/${id}`, {
        params: {
          image,
        },
      })
      .then((res) => {
        toast.dismiss(toastId);
        getSingleProduct();
        toast.success("Image deleted");
      })
      .catch((error) => {
        console.log(error);
        toast.error("Error in deleting Image");
        toast.dismiss(toastId);
      });
  };

  const deleteNewImage = async (index, image) => {
    const toastId = toast.loading("Deleting ...");
    await axios
      .delete(`${server}/api/car/delete-image`, {
        params: {
          image: image.public_id,
        },
      })
      .then((res) => {
        const updatedImages = [...selectedImages];
        updatedImages.splice(index, 1);
        setSelectedImages(updatedImages);

        console.log("updated images");

        toast.dismiss(toastId);
        toast.success("Image deleted");
      })
      .catch((error) => {
        console.log(error);
        toast.error("Error in deleting Image");
        toast.dismiss(toastId);
      });
  };

  return (
    <div className="container marginStyle">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3">
            <AdminMenu />
          </div>
          <div className="col-md-9 my-3">
            <h1 className="text-center">Update Car</h1>
            <div className="m-1 add-car-container">
              <div className="add-car-sub-container">
                {/* <div className="mb-3">
                  <label
                    htmlFor="brand"
                    className="form-label text-gray small-font"
                  >
                    Car Brand
                  </label>
                  <Select
                    bordered={false}
                    placeholder={`${brand.name}`}
                    size="large"
                    className="form-select"
                    onChange={(value) => setbrand(value)}
                  >
                    {brands?.map((c) => (
                      <Option key={c._id} value={c._id}>
                        {c.name}
                      </Option>
                    ))}
                  </Select>
                </div> */}

                <div className="mb-3">
                  <label
                    htmlFor="carName"
                    className="form-label text-gray small-font"
                  >
                    Current Images
                  </label>
                </div>

                <div
                  className="mb-3"
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    justifyContent: "center",
                    overflow: "hidden",
                    maxWidth: "100%",
                  }}
                >
                  {documents.map((image, index) => (
                    <div
                      key={index}
                      className="text-center"
                      style={{ position: "relative" }}
                    >
                      <img
                        src={image.url}
                        alt={`car_image_${index}`}
                        className="img img-fluid"
                        style={{
                          maxWidth: "80px",
                          height: "auto",
                          borderRadius: "5px",
                          objectFit: "cover",
                        }}
                      />
                      <button
                        type="button"
                        className="remove-image-btn"
                        onClick={() => deleteImage(image.public_id)}
                        style={{
                          border: "none",
                          backgroundColor: "none",
                          background: "none",
                          position: "absolute",
                          top: "-2px",
                          right: "10px",
                          color: "red",
                        }}
                      >
                        <IoCloseCircleSharp
                          size={20}
                          style={{ color: "green" }}
                        />
                      </button>
                    </div>
                  ))}
                </div>

                <div className="image-upload mb-3">
                  <label className="upload-label col-md-12">
                    Upload More Images
                    <input
                      type="file"
                      name="productPictures"
                      accept="image/*"
                      multiple
                      onChange={onImageInput}
                      hidden
                    />
                  </label>
                </div>
                <div
                  className="mb-3"
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    justifyContent: "center",
                    overflow: "hidden",
                    maxWidth: "100%",
                  }}
                >
                  {selectedImages.map((image, index) => (
                    <div
                      key={index}
                      className="text-center"
                      style={{ position: "relative" }}
                    >
                      <img
                        src={image.url}
                        alt={`car_image_${index}`}
                        className="img img-fluid"
                        style={{
                          maxWidth: "80px",
                          height: "auto",
                          borderRadius: "5px",
                          objectFit: "cover",
                        }}
                      />
                      <button
                        type="button"
                        className="remove-image-btn"
                        onClick={() => deleteNewImage(index, image)}
                        style={{
                          border: "none",
                          backgroundColor: "none",
                          background: "none",
                          position: "absolute",
                          top: "-2px",
                          right: "10px",
                          color: "red",
                        }}
                      >
                        <IoCloseCircleSharp
                          size={20}
                          style={{ color: "green" }}
                        />
                      </button>
                    </div>
                  ))}
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="carName"
                    className="form-label text-gray small-font"
                  >
                    Car Name
                  </label>
                  <input
                    type="text"
                    value={name}
                    placeholder="Enter car Name"
                    className="form-control"
                    id="carName"
                    onChange={(e) => setname(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="description"
                    className="form-label text-gray small-font"
                  >
                    Car Description
                  </label>
                  <textarea
                    rows={3}
                    value={description}
                    placeholder="Enter car description"
                    className="form-control"
                    id="description"
                    onChange={(e) => setdescription(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="price"
                    className="form-label text-gray small-font"
                  >
                    Car Price
                  </label>
                  <input
                    type="number"
                    value={price}
                    placeholder="Enter car Price"
                    className="form-control"
                    id="price"
                    onChange={(e) => setprice(e.target.value)}
                    min={1}
                    inputMode="numeric"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="fuelType"
                    className="form-label text-gray small-font"
                  >
                    Fuel Type
                  </label>
                  <Select
                    bordered={false}
                    placeholder="Select car Fuel Type"
                    size="large"
                    className="form-select"
                    value={fuelType}
                    id="fuelType"
                    onChange={(value) => setfuelType(value)}
                  >
                    <Option value="Petrol">Petrol</Option>
                    <Option value="Diesel">Diesel</Option>
                  </Select>
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="transmission"
                    className="form-label text-gray small-font"
                  >
                    Transmission Type
                  </label>
                  <Select
                    bordered={false}
                    value={transmission}
                    placeholder="Select car Transmission"
                    size="large"
                    className="form-select"
                    id="transmission"
                    onChange={(value) => settransmission(value)}
                  >
                    <Option value="Automatic">Automatic</Option>
                    <Option value="Manual">Manual</Option>
                  </Select>
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="engineSize"
                    className="form-label text-gray small-font"
                  >
                    Engine Size
                  </label>
                  <input
                    type="number"
                    value={engineSize}
                    placeholder="Enter car Engine Size"
                    className="form-control"
                    id="engineSize"
                    onChange={(e) => setengineSize(e.target.value)}
                    min={1}
                    inputMode="numeric"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="mileage"
                    className="form-label text-gray small-font"
                  >
                    Car Mileage
                  </label>
                  <input
                    type="number"
                    value={mileage}
                    placeholder="Enter car Mileage"
                    className="form-control"
                    id="mileage"
                    onChange={(e) => setmileage(e.target.value)}
                    min={1}
                    inputMode="numeric"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="yom"
                    className="form-label text-gray small-font"
                  >
                    Year of Manufacture
                  </label>
                  <input
                    type="number"
                    value={yom}
                    placeholder="Enter car Year of Manufacture"
                    className="form-control"
                    id="yom"
                    onChange={(e) => setyom(e.target.value)}
                    min={1}
                    inputMode="numeric"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
              </div>

              <div className="add-car-sub-container">
                <div className="mb-3">
                  <label
                    htmlFor="seater"
                    className="form-label text-gray small-font"
                  >
                    Seats
                  </label>
                  <input
                    type="number"
                    value={seater}
                    placeholder="Enter car Seats"
                    className="form-control"
                    id="seater"
                    onChange={(e) => setseater(e.target.value)}
                    min={1}
                    inputMode="numeric"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="drive"
                    className="form-label text-gray small-font"
                  >
                    Drive Type
                  </label>
                  <Select
                    bordered={false}
                    value={drive}
                    placeholder="Select car Drive"
                    size="large"
                    className="form-select"
                    id="drive"
                    onChange={(value) => setdrive(value)}
                  >
                    <Option value="2 WD">2 WD</Option>
                    <Option value="4 WD">4 WD</Option>
                  </Select>
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="horsepower"
                    className="form-label text-gray small-font"
                  >
                    Horsepower
                  </label>
                  <input
                    type="number"
                    value={horsepower}
                    placeholder="Enter car Horsepower"
                    className="form-control"
                    id="horsepower"
                    onChange={(e) => sethorsepower(e.target.value)}
                    min={1}
                    inputMode="numeric"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="torque"
                    className="form-label text-gray small-font"
                  >
                    Torque
                  </label>
                  <input
                    type="number"
                    value={torque}
                    placeholder="Enter car Torque"
                    className="form-control"
                    id="torque"
                    onChange={(e) => settorque(e.target.value)}
                    min={1}
                    inputMode="numeric"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="acceleration"
                    className="form-label text-gray small-font"
                  >
                    Acceleration
                  </label>
                  <input
                    type="number"
                    value={accelaration}
                    placeholder="Enter car Acceleration"
                    className="form-control"
                    id="acceleration"
                    onChange={(e) => setaccelaration(e.target.value)}
                    min={1}
                    inputMode="numeric"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="size"
                    className="form-label text-gray small-font"
                  >
                    Ground Clearance
                  </label>
                  <input
                    type="number"
                    value={size}
                    placeholder="Enter a Ground Clearance"
                    className="form-control"
                    id="size"
                    onChange={(e) => setsize(e.target.value)}
                    min={1}
                    inputMode="numeric"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="fuelTank"
                    className="form-label text-gray small-font"
                  >
                    Fuel Tank Capacity
                  </label>
                  <input
                    type="number"
                    value={fuelTank}
                    placeholder="Enter car FuelTank"
                    className="form-control"
                    id="fuelTank"
                    onChange={(e) => setfuelTank(e.target.value)}
                    min={1}
                    inputMode="numeric"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="safetyrating"
                    className="form-label text-gray small-font"
                  >
                    Safety Rating
                  </label>
                  <input
                    type="number"
                    value={safetyrating}
                    placeholder="Enter car Safety Rating"
                    className="form-control"
                    id="safetyrating"
                    onChange={(e) => setsafetyrating(e.target.value)}
                    min={1}
                    inputMode="numeric"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>

                <div className="mb-3">
                  <button
                    className="btn btn-success mx-2"
                    onClick={handleSubmit}
                  >
                    Update Car
                  </button>
                  <button
                    className="btn btn-outline-danger"
                    onClick={() => navigate("/dashboard/admin/cars")}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateCar;
